var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M8.788 1.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L10 16.354 5.373 19.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273L.553 8.955c-.887-.76-.415-2.212.749-2.305l5.404-.433z","fill":"#fde047","fillRule":"evenodd"}));
}

Star.defaultProps = {"fill":"none","height":"20","width":"20"};

module.exports = Star;

Star.default = Star;
